import { Directive } from '@angular/core';
import { sendTransaction, waitForTransactionReceipt } from '@wagmi/core';
import { ToastrService } from 'ngx-toastr';
import { wagmi_config } from 'src/app/core/config/wagmi_config';
import { SwProcessingService } from 'src/app/core/services/sw-processing.service';

@Directive({
    selector: '[appManageTransactions]',
    standalone: false
})
export class ManageTransactionsDirective {

  constructor(
    private toastr: ToastrService,
    private swProcessingService: SwProcessingService,
  ) { }

  public makeTransactions(params: any) {
    // Marks the transaction as running so a new-build update never reloads the page
    // mid-transaction; released however the transaction ends (see below).
    this.swProcessingService.start();
    const transaction = new Promise(async (resolve, reject) => {
      await sendTransaction(wagmi_config, params).
        then(async (receipt: any) => {
          await waitForTransactionReceipt(wagmi_config,{ hash: receipt })
            .then((response: any) => {
              resolve({ status: true, data: response });
            }).catch((error: any) => {
              reject({ status: false, data: error });
            });

          resolve({ status: true, data: receipt });
        }).catch((error: any) => {
          reject({ status: false, data: error });
          console.log(error, "error")
          if ((error.toString()).includes('User rejected the request') || (error.data.toString()).includes('User rejected the request')) {
            this.toastr.error("User declined the transaction.");
          }
          else {
            this.toastr.error("Something went to wrong");
          }
        })
    });
    transaction.then(() => this.swProcessingService.stop(), () => this.swProcessingService.stop());
    return transaction;

  }
}
